'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import {
  fadeUpAosProps,
  getAosDelay,
  mergeAos,
  zoomInAosProps,
} from '@utils/aosProps';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import CustomImage from '@components/CustomImage';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import DynamicButton from '@components/DynamicButton';
import DynamicLogo from '@components/DynamicLogo';

import cn from './style.module.scss';

export default function EastvaleBanner(props: MarketingPageComponentProps) {
  const bannerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'banner' && section.enabled
  );
  if (!bannerSection) return null;
  return (
    <Stack
      component="section"
      className={cn.eastvaleBannerWrapper}
      {...mergeAos(fadeUpAosProps, getAosDelay(200))}
    >
      <Box className={cn.eastvaleBannerBlock}>
        <Box className={cn.eastvaleBannerStory}>
          <Mobile>
            <CustomImage
              src={bannerSection.eastvaleBannerStoryMobile}
              alt={bannerSection.eastvaleBannerStoryMobile}
              width={1200}
              height={800}
            />
          </Mobile>
          <Desktop>
            <CustomImage
              src={bannerSection.eastvaleBannerStoryDesktop}
              alt={bannerSection.eastvaleBannerStoryDesktop}
              width={1200}
              height={800}
            />
          </Desktop>
        </Box>
        <Box className={cn.eastvaleBannerOverlay}>
          <Box className={cn.eastvaleBannerContent}>
            <Box
              className={cn.eastvaleBannerLogo}
              {...mergeAos(zoomInAosProps, getAosDelay(300))}
            >
              <DynamicLogo
                logoImage={bannerSection.eastvaleBannerLogo}
                alt="Eastvale Logo"
              />
            </Box>
            <Box
              className={cn.eastvaleBannerData}
              {...mergeAos(zoomInAosProps, getAosDelay(400))}
            >
              <Mobile>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(bannerSection.eastvaleBannerHeadingMobile)}
                </ParallaxText>
              </Mobile>
              <Desktop>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(bannerSection.eastvaleBannerHeadingDesktop)}
                </ParallaxText>
              </Desktop>
            </Box>
          </Box>
          <Box className={cn.eastvaleBannerControls}>
            <DynamicButton
              className={cn.eastvaleBannerButton}
              children={bannerSection.eastvaleBannerButton}
              scrollToId="eastvaleRegistration"
            />
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
